module.exports = __webpack_public_path__ + "img/TripCreator-ssLogin.cad6ad43.png";